import {useFormikContext} from "formik";
import {useTranslation} from "react-i18next";
import {FormControl, FormHelperText, InputLabel, MenuItem, Select} from "@mui/material";
import {
    CreateFileMeaningFormValues
} from "@/features/InControlPanel/ReferenceBooks/LaboratoryClarifications/FileMeanings/CreateOrEditFileMeaningDialog";

function ActiveSelector() {
    const {t} = useTranslation();
    const form = useFormikContext<CreateFileMeaningFormValues>();

    return (
      <FormControl
        error={form.touched.active && Boolean(form.errors.active)}
        fullWidth
      >
          <InputLabel>{t("Active")}</InputLabel>
          <Select
            name="active"
            label={t("Active")}
            value={form.values.active ? 1 : 0}
            onChange={async (event) => {
                const value = event.target.value
                await form.setFieldValue("active", Boolean(value));
            }}
            onBlur={form.handleBlur}
            fullWidth
          >
              <MenuItem value={1}>{t("Yes")}</MenuItem>
              <MenuItem value={0}>{t("No")}</MenuItem>
          </Select>

          {(form.touched.active && form.errors.active) && (
            <FormHelperText>
                {t(form.errors.active)}
            </FormHelperText>
          )}
      </FormControl>
    );
}

export default ActiveSelector;
